module.exports = __webpack_public_path__ + "static/media/UncheckCircle.a68d3d2f.svg";